// src/components/DeleteSelectionGroupModal/DeleteSelectionGroupModal.tsx

import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { RemoveModifierFromItem } from '../../../../../../../../../../crud/menu_api/selection_modifiers';
import { toast } from 'react-toastify';

interface Modifier {
    modifier_id: number;
    modifier_name: string;
    modifier_description?: string;
    local_id: number;
}

interface ModifierOption {
    option_id: number;
    modifier_id: number;
    option_name: string;
    option_description?: string;
    price_modifier: number;
}

interface ItemModifier {
    item_id: number;
    item_name: string;
    modifier_id: number;
    is_optional: number;
    is_price_setter: number;
}
interface RemoveOptionFromModifierModalProps {
  show: boolean;
  handleClose: () => void;
  mod: Modifier;
  item:ItemModifier;
  setItems: (data: ItemModifier[]) => void;
  items: ItemModifier[];
}


const RemoveItemModifier: React.FC<RemoveOptionFromModifierModalProps> = ({
  show,
  handleClose,
  mod,
  item,
  setItems,
  items,
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleDelete = () => {
    setLoading(true);
    RemoveModifierFromItem(item.item_id,mod.modifier_id)
      .then((response) => {
        toast.success('Grupo de selección eliminado exitosamente.');
        // Filtrar el grupo eliminado de la lista
        const updatedData = items.filter(
          (i) => i.item_id !== item.item_id
        );
        setItems(updatedData);
        handleClose();
      })
      .catch((error) => {
        console.error('Error eliminando el grupo de selección', error);
        const message =
          error.response?.data?.message || 'Error al eliminar el grupo de selección.';
        toast.error(message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header >
        <Modal.Title>Eliminar Grupo de Selección</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          ¿Estás seguro de que deseas desvincular a {item.item_name} del grupo de modificadores{' '}
          <strong>{mod.modifier_name}</strong>?
        </p>
        
        <p>
          Esta acción no se puede deshacer
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={handleDelete} disabled={loading}>
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{' '}
              Eliminando...
            </>
          ) : (
            'Eliminar'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveItemModifier;
